import { Resource } from '@websolutespa/payload-utils';
import { CollectionSlug } from 'payload';

// naming convention in camelCase

export type LlmSlug = Record<string, CollectionSlug> & {
  llmApp: CollectionSlug;
  llmAppTool: CollectionSlug;
  llmFineTuning: CollectionSlug;
  llmHistory: CollectionSlug;
  llmKbApi: CollectionSlug;
  llmKbAzure: CollectionSlug;
  llmKbConfluence: CollectionSlug;
  llmKbDropbox: CollectionSlug;
  llmKbFile: CollectionSlug;
  llmKbGcs: CollectionSlug;
  llmKbGithub: CollectionSlug;
  llmKbGoogledrive: CollectionSlug;
  llmKbJira: CollectionSlug;
  llmKbS3: CollectionSlug;
  llmKbSftp: CollectionSlug;
  llmKbSharepoint: CollectionSlug;
  llmKbSharepointCustom: CollectionSlug;
  llmKbShopify: CollectionSlug;
  llmKbSitemap: CollectionSlug;
  llmKbSlack: CollectionSlug;
  llmKbThron: CollectionSlug;
  llmKbZendesk: CollectionSlug;
  llmPrompt: CollectionSlug;
  llmRule: CollectionSlug;
  llmThread: CollectionSlug;
  llmTool: CollectionSlug;
  llmUserUpload: CollectionSlug;
  llmVectorDb: CollectionSlug;
  [key: string]: string;
};

export type LlmGroup = {
  llm: string;
  [key: string]: string;
};

export type LlmRoles = {
  LlmEditor: string;
  LlmContributor: string;
};

export type LlmOptions = {
  group: LlmGroup;
  slug: LlmSlug;
  defaultTheme?: Record<string, unknown>;
  translations: Resource;
  roles: LlmRoles;
};

export type LlmInitOptions = {
  group?: Partial<LlmGroup>;
  slug?: Partial<LlmSlug>;
  defaultTheme?: Record<string, unknown>;
  enabled?: boolean;
};

export const LLM_DEFAULT_MIME_TYPES = '.jpg, .jpeg, .png, .svg, .webp, .txt, .md, .pdf, .csv, .doc, .xls, .ppt';
export const LLM_DEFAULT_MAX_FILE_SIZE = 1048576; // 1Mb
// export const LLM_DEFAULT_MAX_FILE_SIZE = 2097152; // 2Mb
